var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearSlide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 174058"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "erase (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 145260",
    transform: "translate(3.088 9.946)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h7.197v.686H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27353",
    d: "M10.409 4.923 7.789 2.2a.644.644 0 0 0-.935 0L2.227 7.01a.705.705 0 0 0 0 .971l1.49 1.572h3.17l3.523-3.659a.705.705 0 0 0 0-.971zm-3.8 3.944H4.005L2.683 7.494l2.085-2.166 2.62 2.718zm1.246-1.291L5.238 4.855 7.31 2.689l2.643 2.722z",
    transform: "translate(-.318 -.637)",
    style: {
      fill: "#231f20"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSlide);
export default __webpack_public_path__ + "static/media/ClearSlide.774b16ca9fc6eae59993c3563362a0fa.svg";
export { ForwardRef as ReactComponent };